var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bootscreen_attendance_main" },
    [
      _c("signin-logo"),
      _c("div", { staticClass: "signin_content" }, [
        _c(
          "div",
          { staticClass: "content_box" },
          [
            _c("signin-header", {
              ref: "signInHeader",
              attrs: { courseInfo: _vm.courseInfo.arrange },
            }),
            _c("signin-enter", {
              ref: "signInEnter",
              attrs: {
                attendType: _vm.courseInfo.attendType,
                attendInfo: _vm.attendInfo,
                addressInfo: _vm.addressInfo,
                currentAddress: _vm.courseInfo.arrange.place,
              },
              on: {
                "update:attendInfo": function ($event) {
                  _vm.attendInfo = $event
                },
                "update:attend-info": function ($event) {
                  _vm.attendInfo = $event
                },
              },
            }),
            _c("signin-case", {
              ref: "signInCase",
              attrs: {
                classNameSet:
                  _vm.courseInfo.arrange && _vm.courseInfo.arrange.classNames
                    ? _vm.courseInfo.arrange.classNames
                    : [],
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }